export const collectionsState = {
    Order: [],
    Service: [],
    Family: [],
    Category: [],
    Clause: [],
    ToolitLogs: [],
};
